<template>
	<div class="card border-left-danger shadow h-100 py-2">
        <div class="card-body">
            <div class="row no-gutters align-items-center">
                <div class="col mr-2">
                    <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">
                        Postulaciones
                    </div>
                    <div 
                    v-if="loading"
                    class="d-flex justify-content-center">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                    <div
                    v-else 
                    class="h5 mb-0 font-weight-bold text-gray-800">
                        {{postulaciones}}
                    </div>
                </div>
                <div class="col-auto">
                    <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {firestore} from '@/firebase.js';
import {mapState} from 'vuex';
export default {
    data(){
        return {
            loading:true,
            postulaciones:0
        }
    },
    methods:{
        ConsultarMisPostulaciones(){
            this.postulaciones=0;
            this.loading=true;
            firestore.collection('clientes').doc(this.usuario.cliente.id)
            .collection('vacantes').where('estatus','==',1)
            .get().then(querySnapshot=>{
                querySnapshot.forEach(doc=>{
                    this.postulaciones=this.postulaciones+Number(doc.data().postulaciones);
                });
            }).catch(error=>{
                console.log(error);
            }).finally(response=>{
                this.loading=false;
            });
        },
        ConsultarPostulacionesTotales(){
            this.postulaciones=0;
            this.loading=true;
            firestore.collection('clientes').where('estatus','==',1)
            .get().then(querySnapshot=>{
                const promises = [];
                querySnapshot.forEach(doc=>{
                    const promise = firestore.collection('clientes')
                    .doc(doc.id).collection('vacantes')
                    .where('estatus','==',1)
                    .get().then(querySnapshot=>{
                        querySnapshot.forEach(doc2=>{
                            this.postulaciones=this.postulaciones+Number(doc2.data().postulaciones);
                        });
                    }).catch(error=>{
                        console.log('error en postulaciones del cliente',error);
                    });
                    promises.push(promise);
                });
                Promise.all(promises).then(results=>{
                    this.loading=false;
                }).catch(error=>{
                    console.log('error en promises',error);
                });
            }).catch(error=>{
                console.log(error);
                this.loading=false;
            })
        },
    },
    computed:{
        ...mapState(['usuario'])
    },
    created(){
        if (this.usuario.cliente.id!=null && this.usuario.cliente.id!='null') {
            this.ConsultarMisPostulaciones();
        }else{
            this.ConsultarPostulacionesTotales();
        }
        
    }
}    
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/postulaciones.vue